import {useState} from "react";

export const SwitchAccountStore = {
  isSwitchingAccount: () => {
    return sessionStorage.getItem("switchingAccount") === "true";
  },
  setSwitchingAccount: () => {
    sessionStorage.setItem("switchingAccount", "true");
  },
  clear: () => {
    sessionStorage.removeItem("switchingAccount");
  },
}

export const useSwitchAccount = () => {
  const [isSwitching, setSwitching] = useState<boolean>(SwitchAccountStore.isSwitchingAccount());
  const enableSwitchAccount = () => {
    SwitchAccountStore.setSwitchingAccount();
    setSwitching(true);

  };
  const clearSwitchAccount = () => {
    SwitchAccountStore.clear();
    setSwitching(false);
  }
  return {isSwitching: isSwitching, enableSwitchAccount, clearSwitchAccount};
};